import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { withRouter } from 'react-router-dom';
import MonacoEditorView from './MonacoEditorView.js';
import SpreadJS from './SpreadJS.js';
import ReactMarkdown from 'react-markdown';
import CodeBlock from "./code-block.js"
import copy from 'copy-to-clipboard';

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';

class Content extends Component {
    constructor(props) {
        super(props);

        this.state = { codeMode: this.props.codeMode || 0 };
        this.onCopy = this.onCopy.bind(this);
        this.onDownload = this.onDownload.bind(this);
        this.viewInGcPdfViewer = this.viewInGcPdfViewer.bind(this);
        this.onDownloadTemplate = this.onDownloadTemplate.bind(this);
        this.onDownloadZip = this.onDownloadZip.bind(this);
        this.onDownloadMaven = this.onDownloadMaven.bind(this);
        this.onJSONExport = this.onJSONExport.bind(this);
        this.onLoading = this.onLoading.bind(this);
        this.updateCodeMirrorCSS = this.updateCodeMirrorCSS.bind(this);
        this.loadTemplateViewer = this.loadTemplateViewer.bind(this);
        this.selectCode = this.selectCode.bind(this);
        this.sJSFromJson = this.sJSFromJson.bind(this);
        window.onresize = this.resizeViewer;
    }

    componentWillReceiveProps(nextProps) {
        Promise.all([
            this.fetchCode(nextProps),
            this.fetchJSON(nextProps),
            this.fetchTemplateReportJSON(nextProps),
            this.fetchScreenshotBase64(nextProps)]
        ).then(values => {
            this.handleFetchResult(values, nextProps);
        }).catch(error => console.log("Error on fetching data: " + error));
    }

    componentWillMount() {
        // 这种写法的好处是fetch到所有数据后再去处理，
        // 之前的写法会导致forceUpdate执行多次，然后触发SpreadJS的bug
        // https://grapecity.atlassian.net/browse/SJS-18715
        Promise.all([
            this.fetchCode(this.props),
            this.fetchJSON(this.props),
            this.fetchTemplateReportJSON(this.props),
            this.fetchScreenshotBase64(this.props)]
        ).then(values => {
            this.handleFetchResult(values, this.props);
        }).catch(error => console.log("Error on fetching data: " + error));
    }

    fetchCode(props) {
        if (!props.page) {
            return;
        }

        //fetch code
        if (props.page.id && (props.page.code === undefined)) {

            let url = props.serverUrl + props.page.id;
            //append language option
            let lang = props.lang || "en-US";
            url += "?lang=" + lang;

            var options = {
                method: 'GET'
            };

            return fetch(url, options).then(function (response) {
                if (response.ok) {
                    return response.json();
                }
            });
        }

        return Promise.resolve();
    }

    fetchJSON(props) {
        if (!props.page) {
            return;
        }

        //fetch json
        if (props.page.id && props.page.showViewer && (props.page.json === undefined)) {
            const url = props.serverUrl + props.page.fileFormatForViewerDisplay + "/" + props.page.id;
            var options = {
                method: 'GET'
            };

            return fetch(url, options).then(function (response) {
                if (response.ok) {
                    if (props.page.fileFormatForViewerDisplay === 'json') {
                        return response.text();
                    } else if (props.page.fileFormatForViewerDisplay === 'sjs') {
                        return response.blob();
                    }
                }
            });
        }
        return Promise.resolve();
    }

    fetchTemplateReportJSON(props) {
        if (!props.page) {
            return Promise.reject();
        }
        var type = props.page.fileFormatForViewerDisplay
        //fetch json
        if (props.page.id && props.page.showViewer && (props.page.templateReportJson === undefined)) {
            const url = props.serverUrl + "templatereport/" + props.page.id + "?type=" + type;
            var options = {
                method: 'GET'
            };

            return fetch(url, options).then(function (response) {
                if (response.ok) {
                    if(type === 'json'){
                        return response.json();
                    }else{
                        return response.blob();
                    }
                }
            });
        }
        return Promise.resolve();
    }

    fetchScreenshotBase64(props) {
        if (!props.page) {
            return;
        }

        if (!props.page.showScreenshot) {
            return;
        }

        if (props.page.id && (props.page.screenshotBase64 == null)) {

            let url = props.serverUrl + "screenshotBase64/" + props.page.id;
            //append language option
            let lang = props.lang || "en-US";
            url += "?lang=" + lang;

            var options = {
                method: 'GET'
            };

            return fetch(url, options).then(function (response) {
                if (response.ok) {
                    return response.json();
                }
            });
        }
        return Promise.resolve();
    }

    handleFetchResult(values, props) {
        this.onLoading(true);
        this.disableButtonsByName("btForCode", props.page.code === undefined);
        var codeIsUpdate = false;
        var jsonIsUpdate = false;
        var templateReportJSONIsUpdate = false;
        var screenshotIsUpdate = false;

        // 处理fetchCode返回值
        var data = values[0];
        if (data && data.id == props.page.id) {
            codeIsUpdate = true;
            props.page.code = data.code;
            props.page.codeKotlin = data.codeKotlin;
            props.page.canDownload = data.canDownload;
            props.page.canDownloadZip = data.canDownloadZip;
            props.page.description = data.description;
            props.page.isFolder = data.isFolder;
        }

        // 处理fetchJson返回值
        data = values[1];
        if (data) {
            jsonIsUpdate = true;
            props.page.json = data;
        }

        // fetchTemplateReportJSON返回值
        data = values[2];
        if (data) {
            templateReportJSONIsUpdate = true;
            props.page.templateReportJson = data;
        }

        // fetchScreenshotBase64返回值
        data = values[3];
        if (data && data.id == props.page.id) {
            screenshotIsUpdate = true;
            props.page.screenshotBase64 = data.screenshotBase64;
        }
        // 只有有东西更新后，才去刷新。
        if (codeIsUpdate || jsonIsUpdate || templateReportJSONIsUpdate || screenshotIsUpdate) {
            this.forceUpdate();
        }
        this.onLoading(false);
    }

    onLoading(isOnLoading) {
        let loadingDiv = document.getElementById("loading");
        if (loadingDiv) {
            loadingDiv.hidden = !isOnLoading;
        }
    }

    disableButtonsByName(buttonName, disable) {
        let bts = document.getElementsByName(buttonName);
        for (let i = 0; i < bts.length; i++) {
            bts[i].disabled = disable;
        }
    }

    shouldComponentUpdate(nextProps, nextState) {
        return nextProps.page.code !== undefined;
    }

    componentDidUpdate() {
        this.updateCodeMirrorCSS();
        this.loadTemplateViewer();
        this.disableButtonsByName("btForCode", (this.props.page.code === undefined));
        this.disableButtonsByName("btForViewer", (this.props.page.json === undefined));
        if (this.refs.tabs) {
            this.refs.tabs.setState({ selectedIndex: this.state.codeMode });
        }
    }

    loadTemplateViewer() {
        let spreadJSViewer = document.getElementById("spreadJSViewer");
        let templateViewer = document.getElementById("templateViewer");

        if (spreadJSViewer && templateViewer && this.isTemplateViewer()) {
            spreadJSViewer.classList.add("templateViewer");
            templateViewer.classList.add("templateViewer");
            templateViewer.classList.remove("disableFeature");
        } else {
            if (spreadJSViewer) {
                spreadJSViewer.classList.remove("templateViewer");
            }
            if (templateViewer) {
                templateViewer.classList.remove("templateViewer");
                templateViewer.classList.add("disableFeature");
            }
        }
    }

    updateCodeMirrorCSS() {
        //Adjust code viewer's height
        let sViewer = ReactDOM.findDOMNode(this.refs.spreadJS);
        if (sViewer) {
            if (this.props.page.showCode) {
                sViewer.classList.remove("codeViewerOnly");
            } else {
                sViewer.classList.add("codeViewerOnly");
            }
            this.refs.spreadJS.refresh();
        }
    }

    onCopy(text, result) {
        if (this.state.codeMode == 0) {
            copy(this.props.page.code);
        } else {
            copy(this.props.page.codeKotlin);
        }

        if (result) {
            this.showMsg(this.props.i18n.copySucceed, true);
        } else {
            this.showMsg(this.props.i18n.copyFailed, false);
        }

        setTimeout(this.clearMsg, 1000);

        dataLayer.push({ 'event': 'TrackEvent', 'eventCategory': 'Code', 'eventAction': 'Copy code', 'eventLabel': "Copy code of " + this.props.page.name });
    }

    showMsg(msg, success) {
        let prompt = document.getElementById("msgPrompt");
        prompt.className = success ? "MsgPrompt" : "MsgPromptFail";
        prompt.innerHTML = msg;
        prompt.hidden = true;
    }

    clearMsg() {
        let prompt = document.getElementById("msgPrompt");
        prompt.hidden = true;
        prompt.innerHTML = "";
    }

    onDownload() {
        if (this.props.page.id) {
            let fileFormat;
            let path;

            if (this.props.page.showPDF) {
                path = this.props.serverUrl + "pdf/" + this.props.page.id;
                window.open(path, "_blank");
            }
            else if (this.props.page.saveCsv) {
                path = this.props.serverUrl + "csv/" + this.props.page.id;
                window.location.href = path;
            }
            else if (this.props.page.saveJson) {
                path = this.props.serverUrl + "json/" + this.props.page.id;
                window.location.href = path;
            }
            else if (this.props.page.saveSJS) {
                path = this.props.serverUrl + "sjs/" + this.props.page.id;
                window.location.href = path;
            }
            else if (this.props.page.jsonToSJS) {
                this.sJSFromJson();
            }
            else {
                path = this.props.serverUrl + "xlsx/" + this.props.page.id;
                window.location.href = path;
            }

            dataLayer.push({ 'event': 'TrackEvent', 'eventCategory': 'Code', 'eventAction': 'Run code', 'eventLabel': path });
        }
    }

    sJSFromJson() {
        if (this.props.page.id) {
            const url = this.props.serverUrl + "jsonForSJS/" + this.props.page.id;
            var sjs = this.refs.spreadJS;
            var id = this.props.page.id;
            var options = {
                method: 'GET'
            };

            fetch(url, options).then(function (response) {
                if (response.ok) {
                    return response.json();
                }
            }).then(function (data) {
                try {
                    sjs.updateJson(data, id);
                } catch (err) {

                } finally {
                }

            }).catch(function (error) {
                console.log('There has been a problem getting the json: ' + error.message);
            });
        }
    }

    viewInGcPdfViewer() {
        if (this.props.page.id) {
            let fileFormat;
            let path;

            if (this.props.page.viewInGcPdfViewer) {
                path = location.origin + window.content_path + "GcPdfViewer/" + this.props.page.id;
                window.open(path, "_blank");
            }

            dataLayer.push({ 'event': 'TrackEvent', 'eventCategory': 'Code', 'eventAction': 'Run code', 'eventLabel': path });
        }
    }

    onDownloadTemplate() {
        if (this.props.page.id) {
            let path = this.props.serverUrl + "template/" + this.props.page.id;
            window.location.href = path;

            dataLayer.push({ 'event': 'TrackEvent', 'eventCategory': 'Template', 'eventAction': 'Download template', 'eventLabel': path });
        }
    }

    onDownloadZip() {
        if (this.props.page.id) {
            let path = this.props.serverUrl + "zip/" + (this.state.codeMode == 0 ? "java/" : "kotlin/") + this.props.page.id;
            window.location.href = path;

            dataLayer.push({ 'event': 'TrackEvent', 'eventCategory': 'Zip', 'eventAction': 'Download zip', 'eventLabel': path });
        }
    }
    onDownloadMaven() {
        if (this.props.page.id) {
            let path = this.props.serverUrl + "maven/" + (this.state.codeMode == 0 ? "java/" : "kotlin/") + this.props.page.id;
            window.location.href = path;

            dataLayer.push({ 'event': 'TrackEvent', 'eventCategory': 'Zip', 'eventAction': 'Download zip', 'eventLabel': path });
        }
    }

    onJSONExport() {
      if (this.props.page.id) {
        let jsonData = this.refs.spreadJS.getJSON();
        var self = this;

        const url = this.props.serverUrl + "fromJSON/" + this.props.page.id;
        var options = {
          method: 'POST',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(jsonData)
        };

        dataLayer.push({ 'event': 'TrackEvent', 'eventCategory': 'Viewer', 'eventAction': 'Export json data', 'eventLabel': url });

        fetch(url, options).then(resp => {
          if (resp.ok) {
            resp.blob().then(blob => {
              saveAs(blob, self.props.page.id + '[FromJson].xlsx');
            })
          }
        })
      }
    }

    selectCode(selectedTabIndex) {
        this.state.codeMode = selectedTabIndex;
        let devLang = selectedTabIndex == 1 ? 'kotlin' : 'java';
        this.props.history.push({
            pathname: window.content_path + this.props.page.id,
            search: "?devLang=" + devLang
        });
    }

    isTemplateViewer() {
        return this.props.page.showTemplateViewer && !this.props.page.isFolder;
    }

    getSpreadLinkContent() {
        if (this.isTemplateViewer()) {
            return this.props.i18n.template;
        } else {
            return this.props.i18n.spreadSheets;
        }
    }


    getViewerContent() {
        if (this.isTemplateViewer()) {
            return '';
        } else {
            return this.props.i18n.viewer;
        }
    }

    resizeViewer() {
        const isNarrow = window.innerWidth < 1000;

        let templateViewer = document.getElementById("spreadJSViewer");
        let reportViewer = document.getElementById("templateViewer");

        if (templateViewer != null) {
            if (isNarrow || !reportViewer) {
                templateViewer.style.width = "100%";
            } else {
                templateViewer.style.width = "50%";
            }
        }

        if (reportViewer != null) {
            if (isNarrow || !templateViewer) {
                reportViewer.style.display = "float";
                reportViewer.style.width = "100%";
            } else {
                reportViewer.style.display = "inline-block";
                reportViewer.style.width = "50%";
            }
        }
    }

    render() {
        let mdRender = { CodeBlock: CodeBlock };

        return (this.props.page &&
            <div className="scContentDiv">
                {(this.props.page.isFolder || this.props.page.id == 'tutorial') && this.props.page.description && (
                    <ReactMarkdown className="description" source={this.props.page.description} renderers={mdRender} />
                )}

                {this.props.page.showCode && (
                    <div >
                        <div className="tag2">{this.props.page.name}</div>

                        {!this.props.page.isFolder && this.props.page.description && (
                            <ReactMarkdown className="descriptionItem" source={this.props.page.description} renderers={mdRender} />
                        )}

                        <Tabs ref="tabs" onSelect={this.selectCode}>
                            <TabList>
                                <Tab>Java</Tab>
                                <Tab>Kotlin</Tab>

                                <div className="buttonBar" style={{ marginTop: '10px' }}>
                                    <button name="btForCode" title={this.props.i18n.btTip_viewInGcPdfViewer} onClick={this.viewInGcPdfViewer} hidden={!this.props.page.viewInGcPdfViewer}><i className="fa fa-play" aria-hidden="true"></i> {this.props.i18n.viewInGcPdfViewer}</button>
                                    <button name="btForCode" title={this.props.page.showPDF ? this.props.i18n.btTip_SaveToPdf : this.props.i18n.btTip_Run} onClick={this.onDownload} hidden={!this.props.page.canDownload}><i className="fa fa-play" aria-hidden="true"></i> {this.props.page.showPDF ? this.props.i18n.saveToPdf : this.props.i18n.run}</button>
                                    <button className="mobileHidden" name="btForCode" title={this.props.i18n.btTip_Template} onClick={this.onDownloadTemplate} hidden={!this.props.page.hasTemplate}><i className="fa fa-download" aria-hidden="true"></i>{this.props.i18n.template}</button>
                                    {/* <CopyToClipboard ref="clipboard" text={this.props.page.code || ""} onCopy={this.onCopy}> */}
                                    <button className="mobileHidden" name="btForCode" onClick={this.onCopy} title={this.props.i18n.btTip_Copy}><i className="fa fa-files-o" aria-hidden="true"></i> {this.props.i18n.copy}</button>
                                    <button name="btForCode" onClick={this.onDownloadZip} title={this.props.i18n.btTip_Download} hidden={!this.props.page.canDownloadZip}><i className="fa fa-download" aria-hidden="true"></i> {this.props.i18n.download}</button>
                                    <button name="btForCode" onClick={this.onDownloadMaven} title={this.props.i18n.btTip_DownloadMaven} hidden={!this.props.page.canDownloadZip}><i className="fa fa-download" aria-hidden="true"></i> {this.props.i18n.downloadMaven}</button>
                                    {/* </CopyToClipboard> */}
                                </div>
                            </TabList>
                            <TabPanel>
                                <MonacoEditorView id="javaCodeMirror" code={this.props.page.code || ""} language="java" notOnlyShowCodeMirror={this.props.page.showViewer || this.props.page.showScreenshot} />
                            </TabPanel>
                            <TabPanel>
                                <MonacoEditorView id="kotlinCodeMirror" code={this.props.page.codeKotlin || ""} language="kotlin" notOnlyShowCodeMirror={this.props.page.showViewer || this.props.page.showScreenshot} />
                            </TabPanel>
                        </Tabs>

                    </div>
                )}

                {(this.props.page.showViewer) && (
                    <div>
                        <div id='spreadJSViewer' style={{verticalAlign:"top"}}>
                            <div className="buttonContainer">
                                <div>
                                    <div className="tag">
                                      <a href={this.isTemplateViewer() ? null : this.props.i18n.spreadSheetsLink}>
                                        <span className="tagText">{this.getSpreadLinkContent()}</span>
                                      </a>
                                    </div>
                                    <div className="tag1">
                                        {this.getViewerContent()}
                                        <span className="readonly">{this.props.page.isViewReadOnly ? this.props.i18n.readonly : ''}</span>
                                    </div>
                                </div>
                                <div className="buttonBar">
                                    <button className="mobileHidden" name="btForViewer" title={this.props.i18n.btTip_Template} onClick={this.onDownloadTemplate} hidden={this.props.page.isViewReadOnly || !this.props.page.hasTemplate}><i className="fa fa-download" aria-hidden="true"></i>{this.props.i18n.template}</button>
                                    <button name="btForViewer" title={this.props.i18n.btTip_Export} onClick={this.onJSONExport} hidden={this.props.page.isViewReadOnly}><i className="fa fa-reply" aria-hidden="true"></i> {this.props.i18n.export}</button>
                                </div>
                            </div>
                            <SpreadJS ref="spreadJS" type={this.props.page.fileFormatForViewerDisplay} json={this.props.page.json} exampleId={this.props.page.id} readOnly={this.props.page.isViewReadOnly} updateFeaturePlugin={this.props.page.updateFeaturePlugin} resizeViewer={this.resizeViewer}/>
                        </div>
                        {this.isTemplateViewer() && (
                            <div id='templateViewer' style={{verticalAlign:"top"}} className='disableFeature'>
                                <div className="buttonContainer">
                                    <div>
                                        <div className="tag">
                                            <a>
                                                <span className="tagText">{this.props.i18n.report}</span>
                                            </a>
                                        </div>
                                        <div className="tag1">
                                            <span className="readonly">{this.props.page.isViewReadOnly ? this.props.i18n.readonly : ''}</span>
                                        </div>
                                    </div>
                                    <div className="buttonBar">
                                        <button className="mobileHidden" name="btForViewer" title={this.props.i18n.btTip_Template} onClick={this.onDownloadTemplate} hidden={this.props.page.isViewReadOnly || !this.props.page.hasTemplate}><i className="fa fa-download" aria-hidden="true"></i>{this.props.i18n.template}</button>
                                        <button name="btForViewer" title={this.props.i18n.btTip_Export} onClick={this.onJSONExport} hidden={this.props.page.isViewReadOnly}><i className="fa fa-reply" aria-hidden="true"></i> {this.props.i18n.export}</button>
                                    </div>
                                </div>
                                <SpreadJS ref="templateResultViewer" type={this.props.page.fileFormatForViewerDisplay} json={this.props.page.templateReportJson} exampleId={this.props.page.id} readOnly={this.props.page.isViewReadOnly} resizeViewer={this.resizeViewer}/>
                            </div>
                        )}
                    </div>
                )}


                {(this.props.page.showScreenshot && this.props.page.screenshotBase64 != null) && (
                    <div>
                        <div className="tag">{this.props.page.screenShotType === "html" ? this.props.i18n.html : this.props.i18n.excel}</div>
                        <div className="tag1">{this.props.i18n.screenshot}</div>
                        <div className="buttonBar">
                            <button className="mobileHidden" name="btForViewer" title={this.props.i18n.btTip_Template} onClick={this.onDownloadTemplate} hidden={this.props.page.isViewReadOnly || !this.props.page.hasTemplate}><i className="fa fa-download" aria-hidden="true"></i>{this.props.i18n.template}</button>
                            <button name="btForViewer" title={this.props.i18n.btTip_Export} onClick={this.onJSONExport} hidden={this.props.page.isViewReadOnly}><i className="fa fa-reply" aria-hidden="true"></i> {this.props.i18n.export}</button>
                        </div>
                        <div className="screenshot">
                            <img src={this.props.page.screenshotBase64} />
                        </div>
                    </div>
                )}

                <div id="msgPrompt" hidden="true" />
                <div id="loading" hidden="true"><i className="fa fa-spinner fa-pulse" aria-hidden="true"></i></div>
            </div>
        );
    }
}

export default withRouter(Content);
